import moment from 'moment';

export const formatWithLocale = dateString => {
  return moment(dateString).format('YYYY/MM/DD HH:mm');
};
